import * as React from "react";
import { AppBar } from "react-admin";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ToggleContractTypeButton from "./ToggleContractTypeButton";
import { GoogleAnalytics4 } from "./GoogleAnalytics4";

const commonStyles = {
  contents: {
    alignItems: "center",
    display: "flex",
    flex: 1,
    flexDirection: { xs: "column", sm: "row" },
    gap: { xs: 0.5, sm: 2 },
    minWidth: 0,
    py: { xs: 0.5, sm: 0 },
  },
  title: {
    flex: 1,
    lineHeight: { xs: 1.25, sm: "normal" },
    minWidth: 0,
    textAlign: { xs: "center", sm: "left" },
    width: "100%",
    overflow: { xs: "visible", sm: "hidden" },
    textOverflow: { xs: "clip", sm: "ellipsis" },
    whiteSpace: { xs: "normal", sm: "nowrap" },
  },
  toggle: {
    display: "flex",
    flex: { xs: "initial", sm: 1 },
    justifyContent: { xs: "center", sm: "flex-start" },
    width: "auto",
  },
};

const MyAppBar = (props: any) => {
  return (
    <AppBar {...props}>
      <Box sx={commonStyles.contents}>
        <Typography variant="h6" color="inherit" sx={commonStyles.title} id="react-admin-title" />
        <Box sx={commonStyles.toggle}>
          <ToggleContractTypeButton />
        </Box>
      </Box>
      <GoogleAnalytics4 />
    </AppBar>
  );
};

export default MyAppBar;
